import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';
import { IconSettingsComponent, IconXComponent, IconSunComponent, IconMoonComponent, IconLaptopComponent } from '@sukna/shared';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'setting',
    templateUrl: './theme-customizer.html',
    imports: [FormsModule, NgClass, NgScrollbarModule, IconSettingsComponent, IconXComponent, IconSunComponent, IconMoonComponent, IconLaptopComponent,TranslateModule],
})
export class ThemeCustomizerComponent {
    store: any;
    showCustomizer = false;
    constructor(
        public storeData: Store<any>,
        public router: Router,
    ) {
        this.initStore();
    }
    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    reloadRoute() {
        window.location.reload();
        this.showCustomizer = true;
    }
}
